import type {ComponentType} from 'react'
import {CourseIdLoader} from '@freckle/classroom/ts/common/components/course-id-loader'
import type {DashboardTypeT} from '@freckle/classroom/ts/common/components/dashboard'
import {Dashboard} from '@freckle/classroom/ts/common/components/dashboard'
import {LaunchDarklyProvider} from '@freckle/classroom/ts/common/components/launch-darkly'
import {NotificationWrapper} from '@freckle/classroom/ts/common/components/notifications-wrapper'
import {MiddlewareWrapper} from './middleware'
import {PendoWrapper} from './pendo-wrapper'

type Props = {
  dashboardType?: DashboardTypeT
  fullScreen?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: ComponentType<any>
}

export function LoggedRoute(props: Props) {
  const {component: Component, dashboardType, fullScreen} = props
  return (
    <MiddlewareWrapper>
      <PendoWrapper>
        <LaunchDarklyProvider>
          <CourseIdLoader>
            <Dashboard dashboardType={dashboardType} fullScreen={fullScreen}>
              <Component />
            </Dashboard>
          </CourseIdLoader>
        </LaunchDarklyProvider>
      </PendoWrapper>
      <NotificationWrapper />
    </MiddlewareWrapper>
  )
}
